<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.5093 67.8995C21.5093 67.8995 20.9973 56.8439 25.0219 56.9629C35.2738 57.2666 76.5196 63.2736 106.317 54.6053"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.3661 71.6919L77.2292 67.7685C77.2054 67.0362 76.5862 66.4588 75.8539 66.4885C74.0738 66.56 72.2104 66.6136 70.2636 66.6433C69.5194 66.6552 68.93 67.2744 68.9538 68.0186L69.0908 71.8943C69.1146 72.6087 69.704 73.1743 70.4184 73.1743C72.2759 73.1743 74.1691 73.1386 76.0921 73.0671C76.8243 73.0374 77.3959 72.4242 77.3721 71.6919H77.3661Z"
            class="primary-fill" />
        <path
            d="M39.7877 68.7806L39.6984 66.2801C39.6746 65.6252 39.1804 65.0835 38.5315 65.0061C37.3706 64.8691 36.1918 64.7203 35.007 64.5655C34.1914 64.4583 33.477 65.1073 33.5068 65.9289L33.5842 68.1555C33.608 68.7627 34.0366 69.2807 34.632 69.4057C35.6143 69.62 36.8169 69.8641 38.216 70.132C39.0554 70.2928 39.8234 69.6319 39.7936 68.7806H39.7877Z"
            class="primary-fill" />
        <path
            d="M57.7186 71.2036L57.5995 67.7208C57.5757 67.0302 57.022 66.4706 56.3314 66.4408C54.8073 66.3754 53.2475 66.292 51.6639 66.1908C50.878 66.1432 50.2232 66.7802 50.2529 67.5601L50.366 70.8345C50.3899 71.4954 50.89 72.0371 51.5448 72.1086C53.063 72.2753 54.6406 72.4301 56.2779 72.567C57.0697 72.6325 57.7424 71.9955 57.7186 71.1977V71.2036Z"
            class="primary-fill" />
        <path
            d="M92.1485 57.6059C92.1485 57.6059 88.0644 48.5209 87.7012 47.2707C87.7012 47.2707 50.2776 50.9738 39.0612 48.6221C38.2099 48.4435 37.3645 48.9198 37.0728 49.7354C36.3881 51.6406 34.6973 56.0283 33.9531 57.2845"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M74.4062 59.13L71.4592 54.0755C71.0604 53.1646 71.6736 52.1287 72.6618 52.0334L88.4445 50.551"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.8184 40.9957L81.5568 46.8718"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M68.6973 39.7216L71.805 48.1696"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.8867 40.9957L55.4395 49.1996"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.7246 43.2997C52.7246 43.2997 68.2096 36.4532 82.8909 41.1028"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.8464 52.3192C46.4126 52.5276 57.8135 53.117 65.0053 52.6645C65.7733 52.6169 66.452 53.1706 66.5473 53.9326L66.6068 54.3851C66.714 55.2305 66.0769 55.9866 65.2256 56.0223C61.5463 56.1771 51.985 56.4152 42.5845 55.2186C41.6676 55.0995 41.0961 54.1708 41.3938 53.3016C41.6081 52.6824 42.2034 52.2835 42.8524 52.3192H42.8464Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M103.884 86.6886C81.7605 82.2533 101.038 54.7006 110.153 57.207C121.988 60.4576 84.1657 109.205 20.4336 71.9002"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M15.6875 78.6456C15.6875 78.6456 28.1839 77.9311 25.7965 79.3361C23.4151 80.7352 21.2838 85.2658 30.0771 84.736C38.8704 84.2061 48.7294 84.2954 45.0025 85.9802C41.2696 87.6591 46.2468 90.0703 55.4866 89.5345C64.7204 88.9987 76.4429 86.8435 72.1742 89.6535C67.9115 92.4636 75.3772 91.6361 81.7712 89.6535C88.1712 87.671 97.0895 85.8493 93.4222 89.0463C89.7608 92.2433 100.423 91.4634 100.423 91.4634"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
